<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Entity Info Section -->
<div class="entity-info-section" [hidden]="minimise">
  <table class="entity-table">
    <tbody>
      <tr>
        <td class="LayerLine1" nowrap>Entity:</td>
        <td class="LayerData1" nowrap>{{rowData.LEID}} - {{rowData.ENTITY_NAME}}</td>
        <td class="LayerLine1" nowrap>Tax Code:</td>
        <td class="LayerData1" nowrap>{{rowData.MARS}}</td>
        <td class="LayerLine1" nowrap>Business:</td>
        <td class="LayerData1" nowrap>{{rowData.PARENT_ME}}</td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <form class="form-horizontal" novalidate>
    
    <!-- Loading Indicator -->
    @if (loading) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}

    <!-- System Summary Section -->
    <div class="systemSummary">
      <div class="leftText nowrap">
        <strong>Local Chart: </strong> {{CHART_DISPLAY}} <br>
        <strong>Local Account: </strong> {{LOCAL_ACCT_DISPLAY}} <br>
        <strong>System Account: </strong> {{SYSTEM_ACC_DISPLAY}}
      </div>
    </div>
    <br>

    <!-- IRS Form Mapping Table -->
    <div class="table-responsive">
      <table class="table table-hover table-bordered table-striped table-condensed custom-table">
        <thead>
          <tr>
            <th>
              <i class="fa pr-5 pointer" aria-hidden="true"
                 [ngClass]="{'fa-sort': sort_key['1'] == 0,
                             'fa-sort-alpha-asc': sort_key['1'] == 1,
                             'fa-sort-alpha-desc': sort_key['1'] == 2}"
                 (click)="orderByField='FORM'; sortBy('1', sort_key['1'])"></i>
              IRS Form
            </th>
            <th>
              <i class="fa pr-5 pointer" aria-hidden="true"
                 [ngClass]="{'fa-sort': sort_key['2'] == 0,
                             'fa-sort-alpha-asc': sort_key['2'] == 1,
                             'fa-sort-alpha-desc': sort_key['2'] == 2}"
                 (click)="orderByField='SCHEDULE'; sortBy('2', sort_key['2'])"></i>
              Schedule
            </th>
            <th>
              <i class="fa pr-5 pointer" aria-hidden="true"
                 [ngClass]="{'fa-sort': sort_key['3'] == 0,
                             'fa-sort-alpha-asc': sort_key['3'] == 1,
                             'fa-sort-alpha-desc': sort_key['3'] == 2}"
                 (click)="orderByField='LINE'; sortBy('3', sort_key['3'])"></i>
              Line No.
            </th>
            <th>
              <i class="fa pr-5 pointer" aria-hidden="true"
                 [ngClass]="{'fa-sort': sort_key['4'] == 0,
                             'fa-sort-alpha-asc': sort_key['4'] == 1,
                             'fa-sort-alpha-desc': sort_key['4'] == 2}"
                 (click)="orderByField='LINE_DESC'; sortBy('4', sort_key['4'])"></i>
              Line Description.
            </th>
            <th>
              <i class="fa pr-5 pointer" aria-hidden="true"
                 [ngClass]="{'fa-sort': sort_key['5'] == 0,
                             'fa-sort-alpha-asc': sort_key['5'] == 1,
                             'fa-sort-alpha-desc': sort_key['5'] == 2}"
                 (click)="orderByField='COL'; sortBy('5', sort_key['5'])"></i>
              Column
            </th>
          </tr>
        </thead>
        <tbody>
          @for (t of sortedSystemAndLocalAccountData; track trackByIndex($index)) {
<tr>
            <td>{{ t.FORM }}</td>
            <td>{{ t.SCHEDULE }}</td>
            <td>{{ t.LINE }}</td>
            <td>{{ t.LINE_DESC }}</td>
            <td>{{ t.COL }}</td>
          </tr>
}
        </tbody>
      </table>
    </div>
    <br>

    <!-- Repointing Description -->
    <div class="row" style="margin-top: 15px;">
      <div class="col-md-6">
        <label>Repointing Desc:</label>
        <input type="text" 
               class="form-control" 
               [ngClass]="{'error-input': showRepointingDescError}"
               placeholder="Enter Repointing Description" 
               [(ngModel)]="Repoint.ADJUSTMENT_DESC" 
               (ngModelChange)="adjDescChanged()"
               name="adjustmentDesc">
      </div>
      <div class="col-md-3" style="margin-top: 25px;">
        @if (showRepointingDescError) {
<div class="form-error-container">Please add repointing description</div>
}
      </div>
    </div>

    <!-- Amount Fields -->
    <div class="row" style="margin-top: 15px;">
      <div class="col-md-3">
        <label>CY Tax Amt:</label>
        <div class="input-group">
          <span class="input-group-addon">{{curr}}</span>
          <input name="cyAmount" 
                 class="form-control" 
                 [ngModel]="cyAmount" 
                 readonly 
                 type="text">
        </div>
      </div>
      <div class="col-md-3">
        <label>Elimination Amt:</label>
        <div class="input-group">
          <span class="input-group-addon">{{curr}}</span>
          <input name="elimAmount" 
                 class="form-control" 
                 [ngModel]="elimAmount" 
                 readonly 
                 type="text">
        </div>
      </div>
      <div class="col-md-3">
        <label>Repointing Amount:</label>
        <div class="input-group">
          <span class="input-group-addon">{{curr}}</span>
          <input readonly 
                 type="text" 
                 name="repointingAmount" 
                 class="form-control" 
                 [ngModel]="repointingAmount">
        </div>
      </div>
      <div class="col-md-3">
        <label>Adjusted Amt:</label>
        <div class="input-group">
          <span class="input-group-addon">{{curr}}</span>
          <input name="remainingCyAmount" 
                 class="form-control" 
                 [ngModel]="remainingCyAmount" 
                 readonly 
                 type="text">
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 15px;">
      <div class="col-md-3">
        <label>Adjusted 5471 Amt:</label>
        <div class="input-group">
          <span class="input-group-addon">{{curr5471}}</span>
          <input name="adjAmount5471" 
                 class="form-control" 
                 [ngModel]="adjAmount5471" 
                 readonly 
                 type="text">
        </div>
      </div>
      <div class="col-md-3">
        <label>Adjusted 8858 Amt:</label>
        <div class="input-group">
          <span class="input-group-addon">{{curr8858}}</span>
          <input name="adjAmount8858" 
                 class="form-control" 
                 [ngModel]="adjAmount8858" 
                 readonly 
                 type="text">
        </div>
      </div>
      <div class="col-md-3 col-md-offset-3" style="margin-top: 5px; margin-bottom: 15px;">
        @if (showRepointingError) {
<div class="form-error-container">
          Repointing amount cannot be greater than current year amount
        </div>
}
      </div>
    </div>
    <br>

    <hr class="separator-line">

    <!-- Loading indicator for lookup data -->
    @if (!loadLookUpData) {
<div class="gt-filter-loading">
      <i style="color: #e12827; font-size: 36px;" class="fa fa-spinner fa-spin"></i>
    </div>
}

    <!-- Repoint List -->
    @if (loadLookUpData) {
<div>
      @for (repoint of repointList; track trackByIndex(i); let i = $index) {
<div style="display: inline;">
        <div class="row">
          <br>
          <div class="col-sm-1">
            <br>
            @if (repoint.DELETE_BTN) {
<i 
               style="font-size: 24px; cursor: pointer;" 
               class="fa fa-minus-circle color-red"
               ap-tooltip
               [tooltipContent]="'Mark Role for Deletion'"
               [direction]="'right'"
               [tooltipId]="'fir-repoint-delete-' + i"
               [attr.aria-describedby]="'fir-repoint-delete-' + i"
               [appendAfterTarget]="true"
               (click)="removeRepointAmount(i, repoint.GROUP_KEY)">
            </i>
}
          </div>

          <!-- IRS Form -->
          <div class="col-md-2">
            <div class="col-md-10">
              <label>IRS Form</label>
              <select class="form-control"
                      [(ngModel)]="repoint.IRS_Form"
                      [ngModelOptions]="{standalone: true}"
                      disabled>
                <option [ngValue]="repoint.IRS_Form">{{repoint.IRS_Form}}</option>
              </select>
            </div>
          </div>

          <!-- Schedule -->
          <div class="col-md-2">
            <div class="col-md-10">
              <label>Schedule</label>
              <select class="form-control"
                      [(ngModel)]="repoint.IRS_SCHEDULE"
                      [ngModelOptions]="{standalone: true}"
                      disabled>
                <option [ngValue]="repoint.IRS_SCHEDULE">{{repoint.IRS_SCHEDULE}}</option>
              </select>
            </div>
          </div>

          <!-- Line -->
          <div class="col-md-2">
            <div class="col-md-12">
              <div class="form-group">
                <label>Line</label>
                <select class="form-control"
                        [(ngModel)]="repoint.IRS_LINE_DESC"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!repoint.IRS_SCHEDULE || repoint.DISABLED"
                        (ngModelChange)="changeLine(repoint); getLookupNext(3, 'COL', repoint)">
                  <option value="">-- Select --</option>
                  @for (line of repoint.loadLookupLineDesc; track $index) {
<option [ngValue]="line">
                    {{line}}
                  </option>
}
                </select>
              </div>
            </div>
          </div>

          <!-- Column -->
          <div class="col-md-2">
            <div class="col-md-10">
              <label>Column</label>
              <select class="form-control"
                      [(ngModel)]="repoint.CHECK_COL"
                      [ngModelOptions]="{standalone: true}"
                      [disabled]="!repoint.IRS_LINE_DESC || repoint.DISABLED"
                      (ngModelChange)="getLookupNext(4, 'SYS_ACCT', repoint)">
                <option value="">-- Select --</option>
                @for (col of repoint.loadLookupColumn; track $index) {

                  @if (col) {
<option [value]="col">{{col}}</option>
}
                
}
              </select>
              @if (repoint.irsColFlag) {
<div class="form-error-container">Please select the column</div>
}
            </div>
          </div>

          <!-- Amount -->
          <div class="col-md-3 amount-col">
            <div class="col-md-12">
              <label>Amount:</label>
              <div class="input-group amount-input-group">
                <span class="input-group-addon">{{curr}}</span>
                <input type="text"
                       class="form-control amount-input"
                       [ngClass]="{'error-input': repoint.acctzeroflag || repoint.AMMOUNT === 0}"
                       name="amount_{{i}}"
                       [(ngModel)]="repoint.AMMOUNT"
                       (ngModelChange)="updateAmt(repoint.GROUP_KEY, repoint.AMMOUNT)"
                       [disabled]="repoint.DISABLED">
              </div>
              @if (repoint.acctzeroflag || repoint.AMMOUNT === 0) {
<div class="form-error-container">
                Amount cannot be zero
              </div>
}
            </div>
          </div>
        </div>
      </div>
}

      <!-- Add Button Row -->
      <div class="row">
        <div class="col-sm-1">
          <i style="font-size: 24px; cursor: pointer;" 
             class="fa fa-plus-circle color-green" 
             ap-tooltip
             [tooltipContent]="'Add New Destination'"
             [direction]="'right'"
             [tooltipId]="'fir-repoint-add'"
             aria-describedby="fir-repoint-add"
             [appendAfterTarget]="true"
             (click)="addRepoint()">
          </i>
        </div>
      </div>
    </div>
}
    <br>
  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          [disabled]="crudLoading"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>

